import React from 'react';
import NotFoundSceneView from './not-found-scene-view';

function NotFoundSceneProvider({ ...props }) {
  return (
    <NotFoundSceneView {...props} />
  );
}

export default NotFoundSceneProvider;
